import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "../../../../theme";

export const ReferralAttachmentContainer = styled(Box)`
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const ReferralHeading = styled(Typography)`
  margin: 10px 10px 10px 0;
`;

export const ReferralSubHeading = styled(Typography)`
  margin: 10px 10px 10px 0;
`;
export const AttachmentType = styled(Typography)`
  color: ${theme.palette.grey[600]};
  align-self: start;
`;

export const FileInfo = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const ReferralFileText = styled(Typography)`
  color: black;
  text-transform: none;
  display: flex;
`;

export const ReferralInfoContainer = styled(Box)`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
`;

export const ReferralInfoText = styled(Typography)`
  margin-bottom: 20px;
`;
